export default "__VITE_ASSET__CP4JG5VF__"